interface ElemInputProps {
	children?: any
	hasError?: any
	errMsg?: any
	leftCount?: any
	label?: any
	required?: any
	value?: any
	labelOnTop?: boolean
}

const ElemInput: React.FC<ElemInputProps> = ({
	label,
	value,
	required,
	hasError,
	errMsg,
	leftCount,
	labelOnTop,
	children,
}) => {
	return (
		<label className={"relative block "}>
			{label && <div className={"font-AcuminWide text-[13px] pb-[6px]"}>{label}</div>}
			{children}

			{leftCount && (
				<div className="absolute top-6 right-3 text-black">
					{value.length}/{leftCount}
				</div>
			)}

			{hasError && <div className="formErrorMsg js-formerror">{hasError.message || errMsg}</div>}
		</label>
	)
}

export default ElemInput
